import React from "react";

import destination_1 from "../../public/wheretogo-jeseniky/praded/destination_1.png";
import destination_2 from "../../public/wheretogo-jeseniky/praded/destination_2.png";
import destination_3 from "../../public/wheretogo-jeseniky/praded/destination_3.png";
import destination_4 from "../../public/wheretogo-jeseniky/praded/destination_4.png";
import destination_5 from "../../public/wheretogo-jeseniky/praded/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-jeseniky/praded/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-jeseniky/praded/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-jeseniky/praded/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-jeseniky/praded/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Praded = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Praděd</h1>
            <p>
              Praděd není jen nejvyšší horou Moravy a oblíbeným výletním cílem,
              ale špička věže na jeho vrcholu se tyčí do nejvyšší dosažitelné
              nadmořské výšky v Česku. Kudy a jak se na Praděd dostanete pěšky,
              na kole nebo na běžkách, s partou zdatných turistů anebo naopak s
              dětmi či seniory.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>vysílací věž</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>restaurace</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>1492 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>horské kolo</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Původně stála na vrcholu 32,5 m vysoká kamenná rozhledna,
                  kterou v letech 1903 - 1912 postavilo Moravskoslezské sudetské
                  horské a turistické sdružení. Věž byla postavena v romantickém
                  duchu starého gotického hradu.
                </li>
                <li>
                  Území Pradědů a jeho okolí je Národní přírodní rezervací,
                  největší rezervací v CHKO Jeseníky. Zahrnuje kromě vrcholu
                  Pradědů jeho hlavní hřeben od Malého Děda po Jelení hřbet a
                  Jelení studánku.
                </li>
                <li>
                  Blízko vrcholu je trojmezní hraniční kámen z r. 1721 se znaky
                  vratislavského biskupství, řádu německých rytířů a panství
                  Žerotínů.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Praded;
